import * as Yup from 'yup'

export const lessonsSchema = Yup.object().shape({
  title: Yup.string().required('Título é obrigatório'),
  resource: Yup.string().required('Conteúdo é obrigatório'),
  order: Yup.string().ensure().required('Ordem é obrigatório')
})
